//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProjectsPreview from '@/components/freelancer/ProjectsPreview.vue'
import ExperiencePreview from '@/components/profile/ExperiencePreview.vue'
import FreelancerFeedbacks from '@/components/freelancer/FreelancerFeedbacks.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'FreelancerProfileTabs',
  components: {
    FreelancerFeedbacks,
    ExperiencePreview,
    ProjectsPreview
  },
  props: {
    freelancer: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    bio () {
      return this.freelancer?.bio || ''
    },

    /**
     * @return {Number}
     */
    flId () {
      return this.freelancer?.id
    }
  }
}
